import { SET_MODEL } from "./constants";
export default {
	[SET_MODEL]: (state, payload) => (state.reservationModel = payload)
};
